<template>
  <div class="city_page">
    <!-- <head-top :head-title="title"></head-top> -->
    <div id="js-container" class="map"></div>
    <div class="city-wrapper">
      <div class="scroller-hook">
        <div class="city_fixed">
          <strong>当前最近城市</strong>
          <p class="current_city" v-if="currentCity !== ''" @click="chooseCurrent">
            {{ currentCity }}
          </p>
        </div>
        <section v-for="(item, key) in cityList" :key="key" :id="item.name">
          <div class="city_title">{{ item.name }}</div>
          <ul>
            <li v-for="(ele, subIndex) in item.cities" :key="subIndex" class="city_item bdb" @click="chooseCity">
              {{ ele }}
            </li>
          </ul>
        </section>
      </div>
      <div class="shortcut-hook">
        <ul @click="bindtouchstart">
          <li v-for="item in cityList" :key="item.name" class="shortcut-item" :data-anchor="item.name">
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
    <loading v-if="showLoading"></loading>
  </div>
</template>
<script>
import BScroll from "better-scroll";
import headTop from "map/head";
import loading from "map/loading";
import fetch from "map/utils/fetch";
import remoteLoad from "map/utils/remoteLoad.js";
import { setStore, getStore, isStringNotNull, myTrim } from "map/utils/util.js";

export default {
  data() {
    return {
      mapKey: "f50ba7028b228f86354bae875dd7f7ce",
      BKey: "TR9oRN8Z73rpnB7GhSRn9D1V51YPLVKm",//百度地图
      scroll: null,
      showLoading: false,
      title: "选择城市",
      currentCity: "",
      cityList: [],
      obj: {},
    };
  },
  created() {
    var url = window.location.href; //当前页面的地址
    var reg = /([^?&=]+)=([^?&=]+)/g,
      obj = {},
      str = url;
    url.replace(reg, function () {
      obj[arguments[1]] = arguments[2];
    })
    for (var keyName in obj) {
      if (keyName == name) {
        return obj[keyName];
        // break;
      }
    }
    console.log(obj);
    this.obj = obj
    // 定位城市
    const currentCity = getStore("map-currentCity");
    // 选择前的城市
    const city = this.$route.query.city;
    if (city) {
      setStore("map-city", city);
    }

    // 如果没有定位城市,重新初始化地图,重新获取当前定位位置
    if (currentCity) {
      this.currentCity = currentCity;
      return;
    }

    let lon = parseFloat(this.$route.query.longitude);
    let lat = parseFloat(this.$route.query.latitude);
    this.getPositionByLonLatsByBaiDu(lon, lat);
  },
  mounted() {
    this.showLoading = true;
    // let citiesStr = getStore("map-storeList");
    // let timestamp = getStore("map-timestamp");
    // // console.log(citiesStr);
    // // console.log(timestamp);
    // if (
    //   citiesStr == undefined ||
    //   new Date().getTime() - parseInt(timestamp) > 30 * 60 * 1000
    // ) {
    //   this.initData();
    // } else {
    //   let cities = JSON.parse(citiesStr);
    //   this.generateCityArray(cities);
    // }
    this.initData();
  },
  components: {
    headTop,
    loading
  },
  methods: {
    getPositionByLonLatsByBaiDu(lon, lat) {
      setTimeout(() => {
        let map = new BMapGL.Map("js-container");
        map.enableScrollWheelZoom(true);
        // 创建地理编码实例      
        var myGeo = new BMapGL.Geocoder();
        // 根据坐标得到地址描述    
        var self = this;
        myGeo.getLocation(new BMapGL.Point(lon, lat), function (result) {
          if (result) {
            self.currentCity = result.addressComponents.city.replace(/市$/, "");
            setStore("map-currentCity", self.currentCity);
          } else {
            console.log("获取城市失败")
          }
        });
      }, 600);
    },

    initData() {
      const _this = this;
      let activityId = null
      let platform = null
      if (this.obj.activityId) {
        activityId = this.obj.activityId;
      }
      fetch("store/getAllStoresWithProviceCityGroup", {
        storeGuide: true,
        activityId,
        platform
      }).then(data => {
        if (data.code > 0) {
          if (data.results != null && data.results != "") {
            const results = JSON.parse(data.results);
            // console.log(results);
            const cities = [];
            for (let key in results) {
              const item = results[key];
              for (let subItem in item) {
                const element = JSON.parse(subItem);
                const { name, abbr } = element;
                // const addr = pinyinUtil.getFirstLetter(name);
                const addr = abbr.charAt(0).toUpperCase();
                cities.push({
                  name,
                  addr,
                  stores: item[subItem]
                });
              }
            }
            _this.generateCityArray(cities);
          }
        } else {
          alert(data.message);
        }
      });
    },
    /**
     * 按字母分类
     */
    generateCityArray(cities) {
      setStore("map-storeList", cities);
      setStore("map-timestamp", new Date().getTime()); //存储一个时间戳，超过半小时即locastorage失效
      let cityList = [];
      let alphaList = [];
      cities.forEach(item => {
        let alpha = item.addr.charAt(0);
        const index = alphaList.findIndex(key => key === alpha);
        if (index === -1) {
          alphaList.push(alpha);
          cityList.push({
            name: alpha,
            cities: [item.name]
          });
        } else {
          cityList[index].cities.push(item.name);
        }
      });
      this.showLoading = false;

      // 根据字母排序!!!
      this.cityList = cityList.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });


      const cityWrapper = document.querySelector(".city-wrapper");
      this.scroll = new BScroll(cityWrapper, {
        probeType: 3,
        click: true,
        tap: true
      });
      this.scroll.scrollTo(0, 0);
    },

    // 点击字母滚动到相应位置
    bindtouchstart(e) {
      const anchor = e.target.getAttribute("data-anchor");
      this.scrollTo(anchor);
    },
    scrollTo(anchor) {
      const cityWrapper = document.querySelector(".city-wrapper");
      const cityScroller = document.querySelector(".scroller-hook");
      const maxScrollY = cityWrapper.clientHeight - cityScroller.clientHeight;
      const scrollToDom = document.getElementById(`${anchor}`);
      const realScrollY = -1 * scrollToDom.offsetTop;
      const y = Math.min(0, Math.max(maxScrollY, realScrollY));
      if (typeof y !== "undefined") {
        this.scroll.scrollTo(0, y);
      }
    },

    chooseCity(e) {
      const city = myTrim(e.target.textContent);
      setStore("map-city", city);
      this.$router.go(-1);
    },
    chooseCurrent() {
      if (isStringNotNull(this.currentCity)) {
        setStore("map-city", this.currentCity);
        this.$router.go(-1);
      }
    }
  }
};
</script>
<style>
.city_page {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: 0;
  background-color: #ffffff;
  z-index: 18;
  overflow: scroll;
  font-size: 14px;
}

.city-wrapper {
  position: relative;
  /* top: 36px;
  height: calc(100% - 36px); */
  top: 0;
  height: 100%;
}

.city_fixed {
  padding: 10px;
}

.city_fixed strong {
  color: #000;
  font-weight: 600;
}

.city_fixed p {
  border-radius: 26px;
  width: 70px;
  text-align: center;
  /* border: 1px solid #dddddd; */
  padding: 3px 0;
  margin-top: 5px;
  background: #FFE9E9;
  color: #393A3B;
  font-size: 16px;
  font-weight: bold;
}

.scroller-hook {
  margin-right: 24px;
}

.city_title {
  font-size: 16px;
  font-weight: bold;
  height: 26px;
  line-height: 26px;
  background-color: #F6F6F6;
  color: #E83E44;
  padding-left: 16px;
}

.city_item {
  color: #393A3B;
  font-size: 16px;
  height: 30px;
  line-height: 30px;
  margin: 8px 16px;
}

.bdb:before {
  display: none;
}

.shortcut-hook {
  width: 24px;
  position: absolute;
  right: 0;
  top: 0;
}

.shortcut-item {
  height: 18px;
  line-height: 18px;
  color: #8C8C8C;
  text-align: center;
  padding-bottom: 10px;
}
</style>
